import { defineStore } from 'pinia';
import { useNuxtApp } from "#app";
import { BlogPostDetailType } from "~/types/blog/BlogPostDetailType";
import { contentAutoMapper } from "~/utils/mappers/content.mapper";

export const useBlogPostStore = defineStore({
    id: 'blogPost',
    state: (): BlogPostDetailType => ({
        slug: undefined,
        title: undefined,
        previewText: undefined,
        content: undefined,
        tags: undefined,
        seo: undefined,
        error: undefined,
    }),
    getters: {},
    actions: {
        async fetchList(slug: string) {
            const config = useRuntimeConfig();

            try {
                const fields = ['slug', 'title', 'preview_text', 'tags'];
                const response = await useNuxtApp().axios.get('/blog-posts', {
                    params: {
                        'filters[slug][$eq]': slug,
                        fields,
                        'populate[content][populate][]': 'image',
                        'populate[seo][populate][]': 'metaImage',
                    }
                });
                if (response?.data?.data === undefined || !response?.data?.data.length) {
                    this.error = createError({ statusCode: 404, statusMessage: 'Page Not Found' });
                    return;
                }

                const data = response?.data?.data[0];

                this.slug = data.attributes?.slug;
                this.title = data.attributes?.title;
                this.previewText = data.attributes?.preview_text;
                this.content = data.attributes?.content.map(content => contentAutoMapper(content, config));
                this.tags = data.attributes?.tags;
                this.seo = data.attributes?.seo;
            } catch (error) {
                console.log(error);
                this.error = error.message;
            }

            return true;
        },
    },
});
